<div class="options-wrapper" [ngClass]="filterClass">
  <div class="active-search input-search-wrapper" *ngIf="filter.values.length > 11 && filter.code !== 'kolor'">
    <input appInputClick
      class="input input-search input-search-after is-Empty"
      autocomplete="off"
      type="text"
      [focusOut]="false"
      [id]="'input-search-' + filter.code"
      [placeholder]="'find' | translate"
      (clickOutside)="loseFocus($event, filterInput)"
      (blur)="updateFilterText($event, filterInput.value)"
      (keyup)="updateFilterText($event, filterInput.value)"
      sdClickOutside
      #filterInput
    />
    <label class="form-label is-Empty" [for]="'input-search-' + filter.code">
      {{ "find" | translate }}
    </label>
    <i class="ai ai-search" (click)="focusFilterInput()"></i>
  </div>

  <ng-container *ngFor="let filterOption of filteredElements; let i = index; trackBy: trackByIndex">

    <ng-container *ngIf="filterOption == null">
      <div class="flex-wrapper-checkbox">
        <span class="checkmark"></span>
        <span class="option gray-line"></span>
      </div>
    </ng-container>

    <ng-container *ngIf="filterOption != null">
      <a *ngIf="filter?.showRealLinks" (click)="$event.stopPropagation(); $event.preventDefault()" onclick="return false;" [href]="getFilterUrl(filter, filterOption)">
        <ng-container *ngTemplateOutlet="flexWrapperCheckbox"></ng-container>
      </a>
      <button *ngIf="!filter?.showRealLinks" (click)="$event.stopPropagation(); $event.preventDefault()">
        <ng-container *ngTemplateOutlet="flexWrapperCheckbox"></ng-container>
      </button>

      <ng-template #flexWrapperCheckbox>
        <div class="flex-wrapper-checkbox"
          (mouseleave)="stopTimerTooltip(filterOption)"
          [ngClass]="{ gray: filterOption.recordCount === 0, active: filterOption.selected }"
          (click)="toggleSelected(filterOption, filter, $event)"
          (mouseover)="delayedOpenTooltip(filterOption)">

          <ng-container *ngIf="canBeShown(i, filter)">
            <input type="checkbox" class="primary-checkbox" [ngClass]="{ checked: filterOption.selected }"/>

            <ng-container *ngIf="filterOption.imageUrl">
              <span class="checkmark" [ngClass]="filterOption.code">
                <img [src]="filterOption.imageUrl" />
                <i *ngIf="filter.code === 'kolor'" class="ai ai-tick tick" [ngClass]="{'white-tick': filterOption.colorSelected !== '#000000' }"></i>
              </span>
            </ng-container>

            <ng-container *ngIf="!filterOption.imageUrl">
              <span class="checkmark" [ngClass]="filterOption.code" [style.background-color]="filterOption.color">
                <i *ngIf="filter.code === 'kolor'" class="ai ai-tick tick" [ngClass]="{'white-tick': filterOption.colorSelected !== '#000000' }"></i>
              </span>
            </ng-container>

            <span class="option" *ngIf="filter.code !== 'kolor'">
              <ng-container *ngIf="filterText.length > 0">
                <span [innerHTML]="boldSearchPhrase(filterOption.value)"></span>
              </ng-container>
              <ng-container *ngIf="filterText.length == 0">
                <span>{{ filterOption.value }} </span>
              </ng-container>
              <span class="count">(<span>{{ filterOption.recordCount }}</span>)</span>
            </span>
          </ng-container>

          <app-tooltip-custom
            [title]="'modalsTexts.noProductFilter' | translate"
            (click)="filterOption['showPopup'] = false"
            *ngIf="filterOption['showPopup']"
            height="92px"
            width="248px">
          </app-tooltip-custom>

        </div>
      </ng-template>
    </ng-container>

  </ng-container>
</div>

<span
  class="success-link body-text show-more-link"
  *ngIf="canDisplayLinkToMore2 && filteredElements.length > 5"
  (click)="toggleShowAllOptions(filter)">
  {{ isFilterShowAll2 ? ("filters.showMain" | translate) : ("filters.showAll" | translate) }}
</span>

<span class="empty-state-filtered-values" *ngIf="filteredElements.length === 0">
  <p>{{ "listing.noFilteredValues" | translate }}</p>
</span>
